"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/SecureText/InsecureTextTag.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _secureText = require('shared/constants/secureText');
var _ClickExplainer = require('./ClickExplainer'); var _ClickExplainer2 = _interopRequireDefault(_ClickExplainer);
var _TextKindLabel = require('./TextKindLabel');





// "Insecure text" label for an SMS patient chat's header. Hovering shows a
// short hint; clicking it (or Enter / Space) opens the insecure-text explainer.
const InsecureTextTag = ({ className }) => (
  _react2.default.createElement(_ClickExplainer2.default, { variant: "insecureChat", className: className, title: `${_secureText.INSECURE_TEXT_LABEL}: click for details`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}
    , _react2.default.createElement('span', { className: "secure-text--tag", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
      , _react2.default.createElement('img', { className: "secure-text--tag--icon", src: _TextKindLabel.UNLOCK_ICON_SRC, alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}} )
      ,  _secureText.INSECURE_TEXT_LABEL 
    )
  )
)

// Short "Insecure" pill for the inbox row, where the full label doesn't fit.
// Clicking the pill opens the explainer (not the chat); the rest of the row
// still opens the chat.
 const InsecureTextPill = ({ className }) => (
  _react2.default.createElement(_ClickExplainer2.default, { variant: "insecureChat", className: className, label: _secureText.INSECURE_TEXT_LABEL, __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
    , _react2.default.createElement('span', { className: "secure-text--tag secure-text--pill" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
      , _react2.default.createElement('img', { className: "secure-text--tag--icon", src: _TextKindLabel.UNLOCK_ICON_SRC, alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}} )
      ,  _secureText.INSECURE_SHORT_LABEL 
    )
  )
); exports.InsecureTextPill = InsecureTextPill

exports. default = InsecureTextTag
